import { SkeletonLines } from "./Skeleton";

/** Platzhalter, waehrend ein per lazy() geladenes Seitenmodul eintrifft. */
export function PageLoading() {
  return (
    <div role="status" aria-live="polite" aria-label="Seite wird geladen">
      <SkeletonLines lines={4} />
    </div>
  );
}
